module.exports = __webpack_public_path__ + "static/media/spb.0a652628.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Offices/img/spb.png
// module id = 804
// module chunks = 0